module.exports = __webpack_public_path__ + "img/ring_y_s_0_1@3x.f88ba1b2.png";